import { FormsRoutingModule } from './form-routing.module';
import { InstanceLiquidationComponent } from './all/instance-liquidation/instance-liquidation.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

// Third party
import { NgArrayPipesModule } from 'ngx-pipes';
import { Ng2FileInputModule, Ng2FileInputComponent } from 'ng2-file-input';
import { BsDropdownModule, TooltipModule } from 'ngx-bootstrap';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { FileUploadModule } from 'primeng/fileupload';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { DocumentViewModule } from 'ngx-document-view';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Local modules
import { SharedModule } from '../shared/shared.module';

// Local components
import { ApproveModifyDocumentComponent, ModifyDocumentInstanceComponent, NoneFormComponent } from '@app/forms/all';
import { ConditionFormComponent } from './all//condition-form/condition-form.component';
import { AssignmentFormComponent } from './all//assignment-form/assignment-form.component';
import { HeaderTitleTaskComponent } from './shared/header-title-task/header-title-task.component';
import { HeaderDescriptionTaskComponent } from './shared/header-description-task/header-description-task.component';
import { ElaborateComponent } from './all/elaborate/elaborate.component';
import { DocsComponent } from './shared/docs/docs.component';
import { ExampleDocsComponent } from './all/example-docs/example-docs.component';
import { ReviewDocumentComponent } from './shared/review-document/review-document.component';
import { ApproveSignComponent } from './shared/approve-sign/approve-sign.component';
import { ApproveComponent } from './all/approve/approve.component';
import { RadicationComponent } from './all/radication/radication.component';
import { DynamicFormsComponent } from './all/dynamic-forms/dynamic-forms.component';
import { RadicationDocsComponent } from './shared/radication-docs/radication-docs.component';
import { LiquidationDeterminationComponent } from './all/liquidation-determination/liquidation-determination.component';
import { ProjectLiquidationComponent } from './all/project-liquidation/project-liquidation.component';
import { AttachedDocumentComponent } from './shared/attached-document/attached-document.component';
import { AttachedComponent } from './all/attached/attached.component';
import { AssignmentComponent } from './shared/assignment/assignment.component';
import { PublicationComponent } from './all/publication/publication.component';
import { DocumentInventoryFormComponent } from './all/document-inventory-form/document-inventory-form.component';
import { DocumentExpInventoryFormComponent } from './all/document-exp-inventory-form/document-exp-inventory-form.component';
import { CopyToComponent } from './shared/copy-to/copy-to.component';
import { SentByComponent } from './shared/sent-by/sent-by.component';
import { RemissionUsersComponent } from './shared/remission-users/remission-users.component';
import { SpecialRadicationComponent } from './shared/special-radication/special-radication.component';
import { ResponseOfComponent } from './shared/response-of/response-of.component';
import { LoadTaskComponent } from './all/instance-liquidation/load-task/load-task.component';
import { DynamicContentFormComponent } from '@app/components/dynamic-content-form/dynamic-content-form.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgArrayPipesModule,
    BrowserModule,
    Ng2FileInputModule,
    ScrollToModule,
    FileUploadModule,
    Ng2SmartTableModule,
    SharedModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    FormsRoutingModule,
    DocumentViewModule,
    PdfViewerModule
  ],
  declarations: [
    NoneFormComponent,
    ConditionFormComponent,
    AssignmentFormComponent,
    HeaderTitleTaskComponent,
    HeaderDescriptionTaskComponent,
    DocsComponent,
    ExampleDocsComponent,
    ReviewDocumentComponent,
    ElaborateComponent,
    ApproveSignComponent,
    ApproveComponent,
    RadicationComponent,
    DynamicFormsComponent,
    RadicationDocsComponent,
    LiquidationDeterminationComponent,
    ProjectLiquidationComponent,
    AttachedDocumentComponent,
    AttachedComponent,
    AssignmentComponent,
    PublicationComponent,
    CopyToComponent,
    SentByComponent,
    RemissionUsersComponent,
    SpecialRadicationComponent,
    ResponseOfComponent,
    InstanceLiquidationComponent,
    LoadTaskComponent,
    DocumentInventoryFormComponent,
    DocumentExpInventoryFormComponent,
    ModifyDocumentInstanceComponent,
    ApproveModifyDocumentComponent,
  ],
  exports: [
    DocsComponent,
    ExampleDocsComponent,
    ReviewDocumentComponent,
  ],
  entryComponents: [
    NoneFormComponent,
    ConditionFormComponent,
    AssignmentFormComponent,
    ExampleDocsComponent,
    Ng2FileInputComponent,
    ElaborateComponent,
    ApproveComponent,
    RadicationComponent,
    DynamicFormsComponent,
    LiquidationDeterminationComponent,
    ProjectLiquidationComponent,
    AttachedComponent,
    PublicationComponent,
    DocumentInventoryFormComponent,
    DocumentExpInventoryFormComponent,
    DynamicContentFormComponent,
    InstanceLiquidationComponent,
    ModifyDocumentInstanceComponent,
    ApproveModifyDocumentComponent,
  ]
})
export class IwFormsModule { }



// WEBPACK FOOTER //
// ./src/app/forms/iw-forms.module.ts